import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './stores';
import { globalVar } from './globalVar';
import './assets/tailwind.css';
import 'animate.css';
import './assets/css/animate.css';

// PrimeVue
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css'
import { ConfirmationService, ToastService } from 'primevue';
import Tooltip from 'primevue/tooltip';

const app = createApp(App);
app.config.globalProperties.$globalVar = globalVar;
app.directive('tooltip', Tooltip);
app.use(store);
app.use(router);
app.use(ConfirmationService);
app.use(ToastService);

// Initialize dark mode on app start
store.dispatch('darkMode/initDarkMode');

app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: false || 'none',
            cssLayer: false
        }
    }
});
app.mount('#app');